import { z } from 'zod';
import {
    WidgetType,
    ZodBaseWidgetConfiguration,
    ZodGenericWidgetConfigurationDetails,
} from '../types';
import { ListData, RowData, RowWithNormalizedData } from '../../DataList/types';
import { zMarshalToBoolean } from '../../ReachApi/Marshallers';
import { DataListColumn } from '../ContentWidget/types';

export const ZodListWidgetConfigurationDetails = ZodGenericWidgetConfigurationDetails.extend({
    list_id: z.string(),
    enable_pagination: z.unknown().transform(zMarshalToBoolean),
    filter_expression: z.string(),
    transform_method: z.string(),
    display_page_indicator: z.unknown().transform(zMarshalToBoolean),
    display_all_pages_before_duration_end: z.string(),
});

export type ListWidgetConfigurationDetails = z.infer<typeof ZodListWidgetConfigurationDetails>;

export const ZodListWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.CONTENT),
    config: ZodListWidgetConfigurationDetails,
});

export type ListWidgetConfiguration = z.infer<typeof ZodListWidgetConfiguration>;

/**
 * The view model for handlebar templates seem unorganized so it will
 * be deprecated in favor of 'context' property found in
 * ListWidgetVueRenderData type
 */
export type ListWidgetTemplateData = {
    list: {
        rows: Array<RowData | RowWithNormalizedData | Record<string, unknown>> | null;
    };
    cols: ListData | null;
    lastUpdated?: number;
    Zone: {
        Id: number;
    };
    viewBag: {
        widgetid: number;
    };

    //Used by Handlebars templates exclusively
    wobj: {
        widget: {
            widgetsid: number;
            config: {
                css: string | null;
            };
        };
    };

    //Used for CSS only
    Widget: {
        Id: number;
    };
} & ListWidgetVueRenderData;

/**
 * Context type for newer templates built with Vue
 */
export type ListWidgetVueRenderData = {
    context?: {
        list: {
            id: string;
            name: string;
            type: string;
        };
        columns: DataListColumn[];
        rows: Array<RowData | RowWithNormalizedData | Record<string, unknown>> | null;
        widget: {
            id: number;
            config: {
                css: string | null;
                enablePagination: boolean;
            };
        };
        zone: {
            id: number;
        };
    };
};

export type ListTransformMethod = (
    rows: Array<RowData | RowWithNormalizedData | Record<string, unknown>>
) => Array<RowData | RowWithNormalizedData | Record<string, unknown>>;
